module.exports = __webpack_public_path__ + "static/media/product-info-icon.4bf406f2.png";